import { render, staticRenderFns } from "./TotalRowsTab.vue?vue&type=template&id=6b021fc5&scoped=true"
import script from "./TotalRowsTab.vue?vue&type=script&lang=js"
export * from "./TotalRowsTab.vue?vue&type=script&lang=js"
import style0 from "./TotalRowsTab.vue?vue&type=style&index=0&id=6b021fc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b021fc5",
  null
  
)

export default component.exports